import { observer } from "mobx-react";
import * as React from "react";
import { Route } from "react-router-dom";
import { CustomSwitch } from "../../app/router/CustomSwitch";
import { ApplicantDetailsSite } from "../sites/ApplicantDetailsSite";
import { ApplicantDocumentsSite } from "../sites/ApplicantDocumentsSite";
import { ApplicantHistorySite } from "../sites/ApplicantHistorySite";
import { ApplicantNotesSite } from "../sites/ApplicantNotesSite";
import { HrRoutes } from "./HrRoutes";

export const HrApplicantInformationRouter = observer(() => (
    <CustomSwitch>
        <Route path={HrRoutes.APPLICANT.DETAILS} component={ApplicantDetailsSite} />
        <Route path={HrRoutes.APPLICANT.DOCUMENTS} component={ApplicantDocumentsSite} />
        <Route path={HrRoutes.APPLICANT.NOTES} component={ApplicantNotesSite} />
        <Route path={HrRoutes.APPLICANT.HISTORY} component={ApplicantHistorySite} />
    </CustomSwitch>
));
